var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgCatchu8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3919 33.0616C25.3492 33.0616 29.3678 32.2156 29.3678 31.1719C29.3678 30.1283 25.3492 29.2822 20.3919 29.2822C15.4347 29.2822 11.416 30.1283 11.416 31.1719C11.416 32.2156 15.4347 33.0616 20.3919 33.0616Z",
    fill: "#1C1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.907 10.1406C28.62 12.1709 28.5784 14.5515 29.2807 15.7677C30.0772 17.1468 32.2845 17.1184 32.2857 20.5796C32.2882 26.0513 27.8553 31.6995 20.8982 31.7883C13.9412 31.8771 7.18353 26.0871 7.38297 18.3013C7.5506 11.7737 12.0447 6.9853 18.6518 6.99024C20.771 6.99147 24.8503 7.70319 26.907 10.1406Z",
    fill: "#ABD7B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5068 22.4498C10.0288 20.0038 7.82638 19.8028 7.42261 19.7041C8.00868 26.772 14.3638 31.87 20.8963 31.7874C21.7197 31.7763 22.5052 31.6961 23.2504 31.5592C15.7513 31.1262 13.0901 25.0698 11.5068 22.4498Z",
    fill: "#96BC9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2675 19.189C19.613 19.1707 19.8752 18.8123 19.853 18.3884C19.8309 17.9646 19.5328 17.6359 19.1873 17.6543C18.8418 17.6726 18.5797 18.0311 18.6019 18.4549C18.624 18.8787 18.922 19.2074 19.2675 19.189Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7607 17.404C27.1129 17.3853 27.3801 17.0194 27.3575 16.5868C27.3349 16.1541 27.0311 15.8185 26.6788 15.8372C26.3266 15.8559 26.0593 16.2218 26.0819 16.6545C26.1046 17.0872 26.4084 17.4227 26.7607 17.404Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8824 20.1378C21.1002 18.7736 22.9294 19.9454 24.1787 19.5939C25.4279 19.2423 25.6065 18.0397 26.7224 18.3382C28.034 18.6897 27.8052 20.9038 25.5613 22.1546C23.3173 23.4053 20.5362 22.3063 20.8824 20.1378Z",
    fill: "#323D33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0617 21.8339C23.7517 21.2492 22.1537 21.433 21.2434 21.6748C22.0461 22.7356 23.9425 23.0563 25.5601 22.1534C25.7412 22.0534 25.9076 21.9449 26.0617 21.8339Z",
    fill: "#D15F53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.3814 9.1365C24.4813 8.78763 23.827 8.29089 22.92 8.02699C22.013 7.76308 21.1967 7.83196 21.0969 8.18082C20.997 8.52969 21.6513 9.02644 22.5583 9.29034C23.4653 9.55424 24.2816 9.48537 24.3814 9.1365Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCatchu8);
export default __webpack_public_path__ + "static/media/img_catchu-8.6988847ba0a24d5b271b0a3849ad6e36.svg";
export { ForwardRef as ReactComponent };